<template lang="pug">
#modal-changepw.modal.fade(tabindex='-1' role='dialog')
  .modal-dialog.modal-dialog-centered.my-0.modal-form
    .modal-content-outside
      .modal-content
        .modal-header.justify-content-start.align-items-center.p-2.border-bottom-0(data-dismiss='modal')
          .arrow-left
            i.fas.fa-chevron-left
          .modal-title.text-capitalize home
        .d-none.d-md-block.lg-close(data-dismiss='modal')
          i.far.fa-times-circle
        .modal-body
          .tab-statement
            ul#pills-tabProfile.nav.nav-pills.mb-3(role='tablist')
              li.nav-item.col.px-2(role='presentation')
                a#pills-changepw-tab.nav-link.active(data-toggle='pill' href='#pills-changepw' role='tab' aria-controls='pills-changepw' aria-selected='false') change password
            #pills-tabProfileContent.tab-content
              #pills-changepw.tab-pane.fade.show.active(role='tabpanel' aria-labelledby='pills-changepw-tab')
                .modal-title-top
                  .text-uppercase.modal-form-title change password
                .bg-profile
                  form.mt-4
                    .input-group.mb-4
                      label.px-2.input-field {{ $t('ui.current_password') }}
                      input.text-center.rounded-pill.form-control(type="text" autocomplete="off" maxlength="20" v-model.trim="$v.oldPassword.$model")
                      validation(:value="$v.oldPassword" :name="$t('ui.current_password')" target="CURRENTPW")
                    .input-group.mb-4
                      label.px-2.input-field {{ $t('ui.new_password') }}
                      input.text-center.rounded-pill.form-control(type="text" autocomplete="off" maxlength="20" v-model.trim="$v.newPassword.$model")
                      validation(:value="$v.newPassword" :name="$t('ui.new_password')" target="NEWPW")
                    .input-group.mb-4
                      label.px-2.input-field {{ $t('ui.confirm_password') }}
                      input.text-center.rounded-pill.form-control(type="text" autocomplete="off" maxlength="20" v-model.trim="$v.confirmPassword.$model")
                      validation(:value="$v.confirmPassword" :name="$t('ui.confirm_password')" target="CONFIRMPW")
                .btn-wrapper
                  .btn-profile
                    a(href='javascript:void(0)' data-dismiss='modal' aria-label='Close')
                      .btn.btn-done {{$t('ui.cancel')}}
                  .btn-profile.text-right
                    a(href='javascript:void(0)' @click="updatePassword")
                      .btn.btn-main {{$t('ui.save')}}
</template>
<script>
import { required, minLength, maxLength, sameAs, not } from 'vuelidate/lib/validators'
import validation from "@/library/_validation.vue"
export default {
  components:{
    validation
  },
  data(){
    return{
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      feedback:{
        success: true,
        status: ""
      },
      loading:false
    }
  },
  validations:{
    oldPassword:{
      required,
    },
    newPassword:{
      required,
      minLength: minLength(6),
      maxLength: maxLength(20),
      isValid : not(sameAs('oldPassword')),
      alphaNumCheck: function(value){
        const containsAlphabet = /[A-Za-z]/.test(value)
        const containsNumber = /[0-9]/.test(value)
        return containsAlphabet && containsNumber
      },
    },
    confirmPassword:{
      required,
      sameAsPassword: sameAs('newPassword')
    },
  },
  computed: {
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    }
  },
  beforeDestroy(){
    this.reset()
  },
  methods:{
    reset() {
      this.oldPassword = ""
      this.newPassword = ""
      this.confirmPassword = ""
      this.feedback.success = true
      this.feedback.status = ""
      this.$v.$reset()
    },
    updatePassword(){
      this.$v.$touch()
      if (!this.$v.$invalid) {
        if(this.sessionToken) {
          let login_id = this.accountID
          let password = this.oldPassword
          let new_password = this.newPassword
          let auth_token = this.sessionToken
          this.loading = true
          this.$store
            .dispatch("user/updatePassword", { login_id, password, new_password, auth_token })
            .then(response => {
              this.loading = false
              this.feedback.success = response.success
              this.feedback.status = response.status
              if (this.feedback.success == true) {
                this.reset()
                $('#modal-changepw').modal('hide')
                this.$helpers.showDialog(this.$t("ui.success").toUpperCase(), this.$t("message.change_password_success"), "success", this);
              } else {
                this.feedback.status = this.$t("error." + response.status)
                if((typeof response.status) != 'object'){
                  this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                }
              }
            })
            .catch(response => {
              this.loading = false
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            });
        }
      }
    }
  }
}
</script>